export enum DiagramKey {
  MAIN = 'main',
  COMPARE_FROM = 'compare-from'
}
